import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';
import { ChatRequest } from '../../services/chatService';
import { toast } from 'react-toastify';
import SendIcon from '@mui/icons-material/Send';
import {
  normalizeChatRequestStatus,
  getChatRequestFeedback,
} from '../../utils/chatRequestStatus';

const ChatRequestButton = ({ userId, pid, ptype }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isSending, setIsSending] = useState(false);

  const handleChatRequest = async () => {
    if (isSending) return;
    setIsSending(true);
    try {
      const response = await ChatRequest({ uid: userId, pid, ptype });

      if (response.statusCode === 200) {
        const status = normalizeChatRequestStatus(response.data);
        const feedback = getChatRequestFeedback(status);

        if (!feedback) {
          toast.error(t('chat.unknownStatus'));
          return;
        }

        toast[feedback.toastType](t(feedback.messageKey));

        if (feedback.shouldNavigateToMessages) {
          navigate('/chat');
        } else if (feedback.shouldNavigateToChatRequests) {
          navigate('/chat/requests');
        }
      } else {
        toast.error(response.message || t('chat.requestError'));
      }
    } catch (error) {
      console.error('Chat request error:', error);
      toast.error(t('chat.requestError'));
    } finally {
      setIsSending(false);
    }
  };

  return (
    <Button
      variant="contained"
      color="primary"
      onClick={handleChatRequest}
      disabled={isSending}
      endIcon={<SendIcon />}
      fullWidth
      sx={{
        mt: 2,
        py: 1.5,
        bgcolor: '#128C7E',
        '&:hover': {
          bgcolor: '#075E54'
        }
      }}
    >
      {isSending ? t('common.loading', 'Gönderiliyor...') : t('advertisement.sendMessage')}
    </Button>
  );
};

export default ChatRequestButton; 